import Service from "../Service";
const resource = "HmnVacations/";

export default {

    save(obj, requestID) {
        return Service.post(resource + "save", obj, {
            params: { requestID: requestID }
        });
    },
    pagination(dtr, requestID) {
        return Service.post(resource + "pagination", dtr, {
            params: { requestID: requestID },
        });
    },
    list(textSearch = "", isAdmin = 0, NtpID = 0, PstID = 0,requestID = 0) {
        return Service.post(resource + "list", {}, {
            params: { textSearch: textSearch, isAdmin: isAdmin, NtpID : NtpID, PstID : PstID, requestID: requestID },
        });
    },
    listEvent(firstFormattedDate, lastFormattedDate, isAdmin, PstID, requestID) {
        return Service.post(resource + "listEvent", {}, {
            params: { 
                firstFormattedDate: firstFormattedDate,
                lastFormattedDate: lastFormattedDate,
                isAdmin: isAdmin,
                PstID : PstID,
                requestID: requestID 
            },
        });
    },
    SendMail(filter, requestID) {
        return Service.post(resource + "SendMail", filter, {
            params: {
                requestID: requestID
            },
        });
    },

    sell(VctID, daysToSell, requestID) {
        return Service.post(resource + "sell", null, {
            params: { VctID: VctID, daysToSell: daysToSell, requestID: requestID },
        });
    },

    accumulate(filter, requestID) {
        return Service.post(resource + "accumulate", filter, {
            params: { requestID: requestID },
        });
    },

};